import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject, takeUntil} from 'rxjs';
import {RecallsVehicle} from '@ox/typings';
import {AppConfigService, AutoDestroy} from '@ox/utils';
import {formatDate} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class RecallsPageService {
  constructor(private appConfig: AppConfigService) {
    this._takataEligibleRecallsNumbers$.pipe(takeUntil(this.destroy$)).subscribe();
  }
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();

  private _recallsVehicle$ = new BehaviorSubject<RecallsVehicle | null>(null);
  public recallsVehicle$ = this._recallsVehicle$.asObservable();
  set recallsVehicle(recallsVehicle: RecallsVehicle) {
    this._recallsVehicle$.next(recallsVehicle);
  }

  private _odometerUpdate$ = new BehaviorSubject<string | null>(null);
  public odometerUpdate$ = this._odometerUpdate$.asObservable();
  set odometerUpdate(odometer: string) {
    this._odometerUpdate$.next(odometer);
  }

  private _odometerUpdateError$ = new BehaviorSubject<boolean>(false);
  public odometerUpdateError$ = this._odometerUpdateError$.asObservable();
  set odometerUpdateError(error: boolean) {
    this._odometerUpdateError$.next(error);
  }

  private _warrantyError$ = new BehaviorSubject<boolean>(false);
  public warrantyError$ = this._warrantyError$.asObservable();
  set warrantError(error: boolean) {
    this._warrantyError$.next(error);
  }

  private _takataEligibleRecallsNumbers$ = new BehaviorSubject<string>('');
  public takataEligibleRecallsNumbers$ = this._takataEligibleRecallsNumbers$.asObservable();
  set takataEligibleRecallsNumbers(currentTakataRecalls: string){
    this._takataEligibleRecallsNumbers$.next(currentTakataRecalls);
  }
  get takataEligibleRecallsNumbers(){
    return this._takataEligibleRecallsNumbers$.value;
  }

  private _takataSignupMessage$ = new BehaviorSubject<boolean|undefined>(undefined);
  public takataSignupMessage$ = this._takataSignupMessage$.asObservable();
  set takataSignupMessage(isSuccessful: boolean){
    this._takataSignupMessage$.next(isSuccessful);
  }

  private _displayTakataWidget$ = new BehaviorSubject<boolean>(false);
  public displayTakataWidget$ = this._displayTakataWidget$.asObservable();
  set displayTakataWidget(show: boolean){
    this._displayTakataWidget$.next(show);
  }



  get getCurrentDate(): string {
    return this.appConfig.locale
      ? formatDate(
          Date.now(),
          this.appConfig.appSettings.moduleConfig.dateFormat.mediumDate,
          this.appConfig.locale
        )
      : '';
  }

  get odometerAttr() {
    return this.appConfig.fieldAttributes.vehicle.odometer;
  }
}
